export default __webpack_public_path__ + "static/media/caen5.ce8d1d22.jpg";